export const getUser = () => {
  const user = window._currentUserInfo;
  const { name, email } = user;
  return {
    userId: user.pid,
    userName: name,
    userEmail: email,
    companyId: user.companyId
  };
};
